import { Fragment } from "react";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";
import { BodyContent } from "./BodyContent";
import styles from "./StaticPage.module.css";

/* Shell for the static content pages.

   Replaces four levels of nested layout tables (PageBody/TitlePanel/ContentNavigate,
   now removed) and a col-lg-2 + col-lg-7 + col-lg-2 grid whose two side columns were
   permanently empty because LeftNav/RightNav were commented out - that left content
   in 7 of 12 columns, off-centre, with a stray leftover column.

   Data contract:
     page          - breadcrumb label
     heading       - page h1
     introduction  - optional node rendered above the panel
     title         - panel header text
     bodyContent   - array of { title?, content } blocks
     wide          - opt out of the capped reading width (see StaticPage.module.css) */
export const PageComponent = ({ Data }) => {
  if (Data == undefined) {
    return <></>;
  }

  return (
    <Fragment>
      <BreadCrumb data={[{ name: Data.page, url: "" }]} />

      <section className={styles.staticSection}>
        <div className="container-fluid container-lg">
          <div className={Data.wide ? styles.contentWide : styles.content}>
            {Data.heading && <h1 className={styles.pageHeading}>{Data.heading}</h1>}

            {Data.introduction && <div className={styles.intro}>{Data.introduction}</div>}

            <div className={styles.panel}>
              {Data.title && <h2 className={styles.panelTitle}>{Data.title}</h2>}

              <div className={styles.panelBody}>
                <BodyContent content={Data.bodyContent} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
